/**
 * The API refuses a change from an applicant whose e-mail is not verified with a 403 whose body carries `code: "EmailNotVerified"`
 * and a message (`RequireVerifiedEmailAttribute`). The verify screen normally stops them first, so this is the safety net: say why
 * and take them to the verify screen, instead of a generic "You don't have permission".
 */
export const EMAIL_NOT_VERIFIED_CODE = "EmailNotVerified";

/** Fired on `window` by the API client when a request is refused for an unverified e-mail; `detail` is the message to show. */
export const EMAIL_NOT_VERIFIED_EVENT = "sep:email-not-verified";

export const EMAIL_NOT_VERIFIED_FALLBACK = "Please verify your email address to continue.";

/** The message to show when a response body is the "e-mail not verified" refusal, otherwise null. */
export function emailNotVerifiedMessage(data: unknown): string | null {
    if (!data || typeof data !== "object") return null;
    const body = data as { code?: unknown; message?: unknown };
    if (body.code !== EMAIL_NOT_VERIFIED_CODE) return null;
    return typeof body.message === "string" && body.message.trim() ? body.message : EMAIL_NOT_VERIFIED_FALLBACK;
}
